// Mirrors the live engine's pdfStyles.js pattern — validated visual decisions from the
// DevExtreme-based exporter (dotted divider, header/group font boost, negative-red, group bg),
// ported as constants for the autotable-based renderer's style hooks (pdfHooksV2.js).
export const PDF_STYLES_V2 = {
    headerBgColor: [255, 255, 255], // explicit white fill on header cells
    // Header font + its bottom border, so the two always move together. Black for now —
    // TODO: swap for a branded color.
    headerAccentColor: [0, 0, 0],
    headerBorderWidth: 0.75,
    groupBg: [255, 255, 255], // #BEDFE6
    // autotable's default 'striped' theme fills every other data row with a light gray
    // (alternateRow: { fillColor: 245 }) unless overridden — explicit white here to kill that
    // banding, matching the header/group backgrounds above.
    alternateRowBgColor: [255, 255, 255],
    negativeColor: [239, 0, 0],
    detailRowDividerColor: '#CCCCCC', // CCCCCC
    detailRowDividerWidth: 0.5,
    detailRowDividerDash: [0.01, 1.5], // near-zero dash + round cap renders as dots, not dashes
    defaultFontSize: 8,
    preferredMinFontSize: 6, // fit-to-page shrinking prefers not to go below this, but will if it must
    headerGroupFontSizeBoost: 2,
    leftMargin: 24,
    rightMargin: 24,
    topMargin: 40, // reserved space for the page letterhead (addHeaderFooterToDoc)
    bottomMargin: 40,
};
